import Link from "next/link";
import React from "react";
import { Button } from "./ui/Button";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const ContactUsPrompt = ({ hideShadow = false }) => {
  const { t } = useTranslation("verifyCode");
  return (
    <div
      className={cn(
        "text-muted-foreground text-center mt-auto mb-8 md:mb-16 xl:mb-24 p-3 rounded-xl bg-background self-center z-10",
        hideShadow ? "" : "shadow-xl"
      )}
    >
      {t("contact_prompt")}
      <Link href="tel:0665044458" passHref>
        <Button variant="link" className="h-fit !py-0 !px-1 font-semibold">
          0665044458
        </Button>
      </Link>
      <br />
      {t("contact_facebook")}
      <Link passHref href="https://www.facebook.com/digitalhomedz">
        <Button className="h-fit !py-0 !px-1 font-semibold" variant="link">
          Digital Home
        </Button>
      </Link>
    </div>
  );
};

export default ContactUsPrompt;
